import type { TRoutes } from "routes/routes";

import { Route } from "routes/route";

export const flattenRoutes = ({
  animationOrderDivider = 1,
  baseAnimationOrder = 0,
  basePath = "",
  flattenedRoutes = [],
  routes,
}: {
  animationOrderDivider?: number;
  baseAnimationOrder?: number;
  basePath?: string;
  flattenedRoutes?: Route[];
  routes: TRoutes;
}) => {
  Object.values(routes).forEach((route) => {
    flattenedRoutes.push(
      new Route({
        animationOrder: route.animationOrder && baseAnimationOrder + route.animationOrder / animationOrderDivider,
        hideSideNav: route.hideSideNav,
        inAnimation: route.inAnimation,
        matches: route.matches.map((match) => basePath + match),
        outAnimation: route.outAnimation,
        Page: route.Page,
        pageId: route.pageId,
        shouldRender: route.isRoleRestricted ? route.shouldRender : undefined,
      }),
    );
    if (route?.subRoutes) {
      route.matches.forEach((match) => {
        flattenRoutes({
          animationOrderDivider: animationOrderDivider * 10,
          baseAnimationOrder: route.animationOrder,
          basePath: basePath + match,
          flattenedRoutes,
          routes: route.subRoutes!,
        });
      });
    }
  });

  return flattenedRoutes;
};
